import { Component, Input } from '@angular/core';
import { SearchTrackerService } from '@app/search/services/search-tracker.service';

/** A generic side-bar panel with a customizable item template */
@Component({
  selector: 'dgx-panel-list',
  templateUrl: './panel-list.component.html',
})
export class PanelListComponent {
  @Input() public collectionName: string;
  @Input() public isLoading: boolean;
  @Input() public totalNumItems: number;
  @Input() public maxDisplayedItems: number;
  @Input() public linkData;

  public skeletons: any[];

  constructor(private searchTrackerService: SearchTrackerService) {}

  public get showViewMore() {
    return this.totalNumItems > this.maxDisplayedItems;
  }

  public ngOnInit() {
    this.skeletons = Array(this.maxDisplayedItems);
  }

  public trackLinkClick() {
    this.searchTrackerService.searchResultViewChanged({
      searchTerm: this.linkData.searchTerm,
      origin: this.linkData.origin,
      linkClicked: this.linkData.collectionLink,
    });
  }
}
